import Chip from 'components/common/Chip';
import styles from './styles.module.scss';
import { Collapse, Image, Skeleton } from 'antd-mobile';
import { FaAngleRight, FaMinus, FaPlus } from 'react-icons/fa6';
import useDirection from 'hooks/useDirection';
import { ROUTES } from 'constants/router';
import { BuildingInfoType } from 'types/property.type';
import { showData } from 'utils/common';
import { useTranslation } from 'react-i18next';

type Props = {
  isSkeleton?: boolean;
  listBuilding?: BuildingInfoType[];
  branchName?: string;
  branchImgUrl?: string;
  numberOfBuilding?: number;
};

export default function PartnerCard({
  branchName,
  branchImgUrl = '',
  numberOfBuilding = 0,
  isSkeleton = false,
  listBuilding = [],
}: Props) {
  const { t } = useTranslation();
  const { goTo } = useDirection();

  return (
    <div className={styles.cardWrapper}>
      <Collapse
        accordion
        defaultActiveKey={'0'}
        arrow={(active) =>
          isSkeleton ? (
            ''
          ) : active ? (
            <FaMinus fontSize={'18px'} color="var(--black) !important" />
          ) : (
            <FaPlus fontSize={'18px'} color="var(--black) !important" />
          )
        }
      >
        <Collapse.Panel
          key={'0'}
          title={
            <div className={styles.topInfo}>
              <div className={styles.buildingLogo}>
                {isSkeleton ? (
                  <Skeleton
                    animated
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                  />
                ) : (
                  <Image src={branchImgUrl} />
                )}
              </div>
              <div className={styles.mainInfo}>
                {isSkeleton ? (
                  <Skeleton
                    animated
                    style={{
                      width: '100%',
                      height: '27px',
                    }}
                  />
                ) : (
                  <p
                    className="font-bold font-lg color-black text-overflow"
                    style={{
                      width: '100%',
                    }}
                  >
                    {showData(branchName)}
                  </p>
                )}
                {isSkeleton ? (
                  <Skeleton
                    animated
                    style={{
                      width: '100%',
                      height: '22px',
                    }}
                  />
                ) : (
                  <div className={styles.chipList}>
                    <Chip content={`${numberOfBuilding} ${t('title.building')}`} color="warning" />
                  </div>
                )}
              </div>
            </div>
          }
        >
          <div className={styles.buildingList}>
            {listBuilding.map((building, idx) => {
              return (
                <div
                  key={idx}
                  className={styles.buildingItem}
                  onClick={goTo(
                    ROUTES.PARTNER_BUILDING.replace(':buildingId', String(building?.id)).replace(
                      ':branchId',
                      String(building?.branchId),
                    ),
                  )}
                >
                  <div className={styles.information}>
                    <div className={styles.buildingName}>
                      <p
                        className="font-bold font-md color-black text-overflow"
                        style={{
                          maxWidth: 'calc(100% - 28px)',
                          width: 'fit-content',
                        }}
                      >
                        {building?.name}
                      </p>
                      {/* <div className={styles.roomIndicator}>
                        <p className="font-bold font-xs color-white">12</p>
                      </div> */}
                    </div>
                    <p className="font-sm color-grey-01">
                      {[building?.address, building?.district?.name, building?.province?.name].join(
                        ', ',
                      )}
                    </p>
                  </div>
                  <FaAngleRight className={styles.icon} fontSize={'18px'} color="var(--black)" />
                </div>
              );
            })}
          </div>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}
